import React, { Fragment } from 'react';
import { Size, FontWeight } from '../../../styles/theme.mjs';
import TextLink from '../../Basic/Link/TextLink/TextLink.mjs';
import TextComponent from '../../Typography/Text/Text.mjs';
import { useTheme } from 'styled-components';

const StoryInfoAuthors = ({ authors }) => {
    const theme = useTheme();
    return (React.createElement(TextComponent, { color: theme.colors.darkGray, tag: "p", size: Size.Tiny }, authors.map((author, index) => {
        const isLast = index === authors.length - 1;
        return (React.createElement(Fragment, { key: author.id },
            index > 0 && (isLast ? ' and ' : ', '),
            author.href ? (React.createElement(TextLink, { underlined: true, color: "inherit", href: author.href, size: Size.Small, className: "author author-link" }, author.name)) : (React.createElement(TextComponent, { className: "author", color: "inherit", tag: "span", size: Size.Tiny, fontWeight: FontWeight.Medium }, author.name))));
    })));
};

export { StoryInfoAuthors as default };
//# sourceMappingURL=StoryInfoAuthors.mjs.map
